"use client";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { cn } from "@/lib/utils";
import { useTranslations } from "next-intl";
import React from "react";

interface FAQItem {
  ask: string;
  answer: string;
  category: CategoryType | any;
}

type CategoryType =
  | "Mobile Apps"
  | "Pendanaan Budidaya"
  | "Pendanaan Kandang"
  | "Ayam dan Telur"
  | "Livebird"
  | "IoT"
  | "ERP"
  | "Pertanyaan yang paling sering diajukan";


export default function Question() {
  const t = useTranslations("FAQ");

  const categories: CategoryType[] | any[] = [
    t("categoriesLabel.MobileApps"),
    t("categoriesLabel.PendanaanBudidaya"),
    // t("categoriesLabel.PendanaanKandang"),
    t("categoriesLabel.AyamdanTelur"),
    t("categoriesLabel.Livebird"),
    t("categoriesLabel.IoT"),
    t("categoriesLabel.ERP"),
    t("categoriesLabel.PertanyaanPalingSering"),
  ];

  const FAQItems: FAQItem[] = [
    // MOBILE APP
    {
      ask: t('items.App.One.ask'),
      answer: t.raw('items.App.One.answer'),
      category: t('items.App.One.category'),
    },
    {
      ask: t('items.App.Two.ask'),
      answer: t.raw('items.App.Two.answer'),
      category: t('items.App.Two.category'),
    },
    {
      ask: t('items.App.Three.ask'),
      answer: t.raw('items.App.Three.answer'),
      category: t('items.App.Three.category'),
    },
    {
      ask: t('items.App.Four.ask'),
      answer: t.raw('items.App.Four.answer'),
      category: t('items.App.Four.category'),
    },

    // MOBILE APP


    // PENDANAAN BUDIDAYA
    {
      ask: t('items.PendanaanBudidaya.One.ask'),
      answer: t.raw('items.PendanaanBudidaya.One.answer'),
      category: t('items.PendanaanBudidaya.One.category'),
    },
    {
      ask: t('items.PendanaanBudidaya.Two.ask'),
      answer: t.raw('items.PendanaanBudidaya.Two.answer'),
      category: t('items.PendanaanBudidaya.Two.category'),
    },


    // PENDANAAN BUDIDAYA

    // PENDANAAN KANDANG
    {
      ask: t('items.PendanaanKandang.One.ask'),
      answer: t.raw('items.PendanaanKandang.One.answer'),
      category: t('items.PendanaanKandang.One.category'),
    },
    {
      ask: t('items.PendanaanKandang.Two.ask'),
      answer: t.raw('items.PendanaanKandang.Two.answer'),
      category: t('items.PendanaanKandang.Two.category'),
    },
    {
      ask: t('items.PendanaanKandang.Three.ask'),
      answer: t.raw('items.PendanaanKandang.Three.answer'),
      category: t('items.PendanaanKandang.Three.category'),
    },

    // PENDANAAN KANDANG

    // AYAM DAN TELUR
    {
      ask: t('items.AyamTelur.One.ask'),
      answer: t.raw('items.AyamTelur.One.answer'),
      category: t('items.AyamTelur.One.category'),
    },
    {
      ask: t('items.AyamTelur.Two.ask'),
      answer: t.raw('items.AyamTelur.Two.answer'),
      category: t('items.AyamTelur.Two.category'),
    },
    {
      ask: t('items.AyamTelur.Three.ask'),
      answer: t.raw('items.AyamTelur.Three.answer'),
      category: t('items.AyamTelur.Three.category'),
    },
    {
      ask: t('items.AyamTelur.Four.ask'),
      answer: t.raw('items.AyamTelur.Four.answer'),
      category: t('items.AyamTelur.Four.category'),
    },
    {
      ask: t('items.AyamTelur.Five.ask'),
      answer: t.raw('items.AyamTelur.Five.answer'),
      category: t('items.AyamTelur.Five.category'),
    },
    {
      ask: t('items.AyamTelur.Six.ask'),
      answer: t.raw('items.AyamTelur.Six.answer'),
      category: t('items.AyamTelur.Six.category'),
    },
    {
      ask: t('items.AyamTelur.Seven.ask'),
      answer: t.raw('items.AyamTelur.Seven.answer'),
      category: t('items.AyamTelur.Seven.category'),
    },
    {
      ask: t('items.AyamTelur.Eight.ask'),
      answer: t.raw('items.AyamTelur.Eight.answer'),
      category: t('items.AyamTelur.Eight.category'),
    },
    {
      ask: t('items.AyamTelur.Nine.ask'),
      answer: t.raw('items.AyamTelur.Nine.answer'),
      category: t('items.AyamTelur.Nine.category'),
    },

    // AYAM DAN TELUR

    // LIVEBIRD
    {
      ask: t('items.LiveBird.One.ask'),
      answer: t.raw('items.LiveBird.One.answer'),
      category: t('items.LiveBird.One.category'),
    },
    {
      ask: t('items.LiveBird.Two.ask'),
      answer: t.raw('items.LiveBird.Two.answer'),
      category: t('items.LiveBird.Two.category'),
    },
    {
      ask: t('items.LiveBird.Three.ask'),
      answer: t.raw('items.LiveBird.Three.answer'),
      category: t('items.LiveBird.Three.category'),
    },

    // LIVEBIRD

    // IOT
    {
      ask: t('items.IoT.One.ask'),
      answer: t.raw('items.IoT.One.answer'),
      category: t('items.IoT.One.category'),
    },
    {
      ask: t('items.IoT.Two.ask'),
      answer: t.raw('items.IoT.Two.answer'),
      category: t('items.IoT.Two.category'),
    },
    {
      ask: t('items.IoT.Three.ask'),
      answer: t.raw('items.IoT.Three.answer'),
      category: t('items.IoT.Three.category'),
    },

    // IOT

    // ERP
    {
      ask: t('items.ERP.One.ask'),
      answer: t.raw('items.ERP.One.answer'),
      category: t('items.ERP.One.category'),
    },
    {
      ask: t('items.ERP.Two.ask'),
      answer: t.raw('items.ERP.Two.answer'),
      category: t('items.ERP.Two.category'),
    },
    {
      ask: t('items.ERP.Three.ask'),
      answer: t.raw('items.ERP.Three.answer'),
      category: t('items.ERP.Three.category'),
    },
    // ERP

    // MOST QUEST
    {
      ask: t('items.MostQuest.One.ask'),
      answer: t.raw('items.MostQuest.One.answer'),
      category: t('items.MostQuest.One.category'),
    },
    {
      ask: t('items.MostQuest.Two.ask'),
      answer: t.raw('items.MostQuest.Two.answer'),
      category: t('items.MostQuest.Two.category'),
    },
    {
      ask: t('items.MostQuest.Three.ask'),
      answer: t.raw('items.MostQuest.Three.answer'),
      category: t('items.MostQuest.Three.category'),
    },
    // MOST QUEST
  ];
  const [selected, setSelected] = React.useState(0);

  return (
    <>
      <section className="w-full my-10">
        <div className=" bx-container">
          <h5 className="text-[#667085] tracking-widest uppercase font-semibold block w-full">
            FAQ
          </h5>
          <h2 className="mt-6 mb-10 text-xl md:text-3xl font-medium max-w-full">
            {t("categoryLabel")}
          </h2>

          <div className="flex flex-wrap gap-2 md:gap-4">
            {categories.map((it, i) => (
              <button
                key={it}
                onClick={() => {
                  setSelected(i);
                }}
                className={cn(
                  "border rounded-md py-4 px-6 hover:border-[#F5BE01] hover:bg-[#FEF8E2] ",
                  selected == i ? "border-[#F5BE01] bg-[#FEF8E2]" : ""
                )}
              >
                {it}
              </button>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#F9FAFB] w-full">
        <div className=" bx-container">
          <h5 className="text-[#667085] tracking-widest uppercase font-semibold block w-full">
            FAQ
          </h5>
          <h2 className="mt-6 mb-10 text-xl md:text-3xl font-medium max-w-full lg:max-w-[50%]">
            {t("topFAQLabel")}
          </h2>

          <Accordion type="multiple" className="w-full">
            {FAQItems.filter((it) => it.category == categories[selected]).map((it, i) => (
              <AccordionItem
                key={it.ask}
                value={it.ask}
                className="bg-white rounded-md mb-6 px-10"
              >
                <AccordionTrigger>{it.ask}</AccordionTrigger>
                <AccordionContent className="flex flex-col gap-3 p-6">
                  {/* {it.answer} */}
                  <div dangerouslySetInnerHTML={{ __html: it.answer }} />
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </>
  );
}
